import { Membership } from 'src/types'

export const getMembershipName = (membership: Membership) => {
  const membershipName = membership.isBuyer
    ? membership.buyerCompanyName
    : membership.sellerCompanyName

  return membershipName as string
}
